module.exports = __webpack_public_path__ + "static/media/ICON_SHARE.2315183b.svg";